import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetProfitabilityReport } from "../services/reports.services";

const ProfitabilityReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/profitabilityreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/profitabilityreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterDestination = params?.filterDestination;
  const filterRequirementType = params?.filterRequirementType;
  const filterUser = params?.filterUser;

  const loading = useAppSelector((state) => state.reports.loading);
  const ProfitabilityListForReport = useAppSelector(
    (state) => state.reports.ProfitabilityListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: filterDestination !== "0" ? filterDestination : "",
        RequirementType:
          filterRequirementType !== "0" ? filterRequirementType : "",
        UserID: filterUser !== "0" ? filterUser : 0,
      };
      dispatch(GetProfitabilityReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "ProfitabilityReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "profitabilityreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Profitability Report{" "}
          <span style={{ fontSize: 15 }}>
            {ProfitabilityListForReport &&
              ProfitabilityListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            ProfitabilityListForReport &&
            ProfitabilityListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            ProfitabilityListForReport &&
            ProfitabilityListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {ProfitabilityListForReport && ProfitabilityListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  TripID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Customer Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Destination
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Purchase cost
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Selling Price
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Profit
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Profit %
                </th>
              </tr>
            </thead>
            <tbody>
              {ProfitabilityListForReport &&
                ProfitabilityListForReport.length > 0 &&
                ProfitabilityListForReport?.map(
                  (Profitability: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {Profitability?.TripID || ""}
                      </td>
                      <td className="text-center">
                        {Profitability?.CustomerName || ""}
                      </td>
                      <td className="text-center">
                        {Profitability?.Destination || ""}
                      </td>
                      <td className="text-end">
                        {Profitability?.PurchaseCost
                          ? formatIndianNumber(+Profitability?.PurchaseCost)
                          : ""}
                      </td>
                      <td className="text-end">
                        {Profitability?.SellingPrice
                          ? formatIndianNumber(+Profitability?.SellingPrice)
                          : ""}
                      </td>
                      <td className="text-end">
                        {Profitability?.ProfitRs
                          ? formatIndianNumber(+Profitability?.ProfitRs)
                          : ""}
                      </td>
                      <td className="text-end">
                        {Profitability?.ProfitPercentage
                          ? Profitability?.ProfitPercentage
                          : ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default ProfitabilityReportView;
